import React from 'react';
import { useGlobalValue } from '../../state/GlobalProvider';
import styles from './Widget.module.sass';

const WidgetSummary = props => {
  const {
    summary
  } = props;
  const {
    i18n
  } = useGlobalValue();
  return /*#__PURE__*/React.createElement("div", {
    className: styles['summary']
  }, summary.map(({
    name,
    value
  }, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: styles['summary-item']
  }, /*#__PURE__*/React.createElement("small", null, i18n`${name}`, ": "), /*#__PURE__*/React.createElement("strong", null, value))));
};

export default WidgetSummary;